// src/modules/app-views/_apps/appmulti/coupons/pages/Document/tabs/UsesTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card, Table, Empty } from 'antd';
import dayjs from 'dayjs';
import { useDocumentContext } from 'components/core/DocumentProvider';
import translateX from 'utils/translateX';
import financialService from 'services/financialService';

// *******************************************************************************
// GLOBAL VARIABLES
// *******************************************************************************
const COLUMNS = [
  {
    title: translateX('date'),
    dataIndex: 'usedAt',
    width: 180,
    render: v => (v ? dayjs(v).format('L LT') : '—'),
  },
  {
    title: translateX('order'),
    dataIndex: 'orderId',
    width: 240,
    render: v => (v ? String(v) : '—'),
  },
  {
    title: translateX('discount_value'),
    dataIndex: 'discountValue',
    width: 160,
    align: 'right',
    render: v => {
      if (v == null) return '—';
      const f = financialService.formatNumber(v, { decimals: 2, locale: 'pt-BR' });
      return `R$ ${f}`;
    },
  },
];

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const UsesTab = () => {
  // ---------------------------------------------------------------------------
  // PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------
  const { data } = useDocumentContext();

  // ---------------------------------------------------------------------------
  // LOCAL VARIABLES I
  // ---------------------------------------------------------------------------
  const uses = Array.isArray(data?.uses) ? data.uses : [];

  // ---------------------------------------------------------------------------
  // UI
  // ---------------------------------------------------------------------------
  return (
    <div className="container mt-3">
      <Card title={translateX('usage_history')}>
        {uses.length === 0 ? (
          <Empty description={translateX('no_usage_yet')} />
        ) : (
          <Table
            rowKey="_id"
            size="small"
            bordered
            columns={COLUMNS}
            dataSource={uses}
            pagination={false}
            scroll={{ x: 'max-content' }}
          />
        )}
      </Card>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default UsesTab;
